import { lazyComponent } from '@/utils/lazyComponent'

export default lazyComponent(() => import('./InventoryStatusRoute'))
